exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#nav_tab[data-v-0d3b1294]{position:relative;border-width:4px 0 0;background-color:#fff;box-shadow:0 0 5px 5px rgba(0,0,0,.08)}#nav_tab[data-v-0d3b1294]:before{background:none}#title[data-v-0d3b1294]{width:-moz-fit-content;width:fit-content;padding:0 15px;font-family:WWF;font-size:2.5em;margin-left:15px}.nav-link[data-v-0d3b1294]{color:#000;font-family:WWF;font-size:1.8em}#update-info-btn[data-v-0d3b1294]{font-size:1.1em;margin-top:20px;background-color:#e65959;font-weight:700}", ""]);

// exports
